// extracted by css-extract-rspack-plugin
module.exports =  {"container":"CopyToPortfolioView-QfPM__container"};